"use client";
import { ChevronDown, Calendar, X } from "lucide-react";
import { useEffect, useState } from "react";

export default function ServiceRequest({ formData, onClose }) {
  const [currentDateTime, setCurrentDateTime] = useState("");

  useEffect(() => {
    const now = new Date();

    const day = now
      .getDate()
      .toString()
      .padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    let hour = now.getHours();
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12; // the hour '0' should be '12'
    const minute = now
      .getMinutes()
      .toString()
      .padStart(2, "0");

    setCurrentDateTime(`${day}th ${month}, ${hour}:${minute} ${ampm}`);
  }, []); // Empty dependency array means this effect runs only once after the initial render

  return (
    <div className="bg-white rounded-lg w-full max-w-md mx-auto">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b">
        <h1 className="text-xl font-bold">Service Request</h1>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        {/* Event Card */}
        <div className="bg-white border border-gray-100 rounded-lg p-4 shadow-sm">
          <div className="flex justify-between items-center">
            <div>
              <h3 className="font-bold text-lg">
                {formData.eventName || "Our Gender Reveal Party"}
              </h3>
              <div className="flex items-center mt-1 text-gray-500">
                <Calendar size={14} className="mr-1" />
                <span className="text-sm">
                  {formData.date || "13th Nov, 11:00 AM"}
                </span>
              </div>
            </div>
            {/*
            <button className="text-[#7B189F] flex items-center text-sm font-medium">
              View more <ChevronDown size={16} className="ml-1" />
            </button>
            */}
          </div>
        </div>

        {/* Timeline */}
        <div className="space-y-4">
          {/* Event Placed */}
          <div className="flex items-start">
            <div className="relative mr-4">
              <div className="w-4 h-4 rounded-full bg-green-400" />
              <div className="absolute top-4 bottom-0 left-1/2 w-px -translate-x-1/2 bg-gray-200 h-12" />
            </div>
            <div>
              <h3 className="font-medium">Event Placed & Quote Request Sent</h3>
              <div className="flex items-center mt-1 text-gray-500">
                <Calendar size={14} className="mr-1" />
                <span className="text-sm">{currentDateTime}</span>
              </div>
            </div>
          </div>

          {/* In Progress */}
          <div className="flex items-start">
            <div className="mr-4">
              <div className="w-4 h-4 rounded-full bg-[#7B189F]" />
            </div>
            <div>
              <h3 className="font-medium text-[#7B189F] uppercase">
                In progress
              </h3>
              <p className="text-sm mt-1">Vendor yet to contact</p>
              <p className="text-sm text-gray-500 mt-1">
                Vendor is expected to contact you by 9th Nov.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
